import React from "react";

const ScenarioSelector = ({ scenarios, activeKey, onSelect, isDarkMode }) => {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {scenarios.map((s) => {
        const isActive = s.key === activeKey;
        return (
          <button
            key={s.key}
            onClick={() => onSelect(s.key)}
            className={`
              relative px-3 py-1.5 rounded-lg text-xs font-semibold transition-all duration-200
              ${isActive
                ? isDarkMode
                  ? "bg-emerald-600 text-white"
                  : "bg-emerald-500 text-white"
                : isDarkMode
                  ? "bg-gray-800 text-gray-400 hover:bg-gray-700"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }
            `}
          >
            {s.name.replace("Scénario ", "").replace("Scenario ", "")}
          </button>
        );
      })}
    </div>
  );
};

export default ScenarioSelector;
